// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__a5jtr","spin":"spinner_spin__L891Y"};